import {Component, OnInit, Input} from '@angular/core';
import {MediaService} from '../../pages-services/media.service';
import {HttpClient} from '@angular/common/http';
import { ToasterService } from 'angular2-toaster';
import { TranslateService } from '@ngx-translate/core';
import { ChangesSubject, DataChangesObserver } from '@common-lib';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs'
import { timer } from 'rxjs/observable/timer';
import { Lightbox } from 'ngx-lightbox';

@Component({
    selector: 'app-media',
    templateUrl: './media.component.html',
    styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit {
    @Input() selectedProducts: any[] = [];

    requestStatus$: Observable<number>;
    timeInterval : number = 20000;
    sub: Subscription;

    statusSync = ''
    haveChanges = false;
    thumbnailsOnPage = 30;
    activeCollapse = '';
    changesCount = 0;
    changesSubject: ChangesSubject;
    assetsVersion: string;
    products = [{
        name: '',
        activePage: {},
        folders: [{
            images: [ ]
        }]
    }];
    basePath = '';
    isImageUploading = false;
    isSync = false;
    wichFolderUploading = '';
    wichFileDeleting = '';
    media = [];

    activeTab = 'products';

    private _album = [];

    constructor(
        private mediaService: MediaService,
        private http: HttpClient,
        private toasterService: ToasterService,
        private translationService: TranslateService,
        private datachanges: DataChangesObserver,
        private _lightbox: Lightbox
    ) {
    }

    open(path: string): void {
      let alb = [{
        src: path,
        caption: path,
        thumb: path
      }];

      this._lightbox.open(alb, 0);
    }

    close(): void {
      this._lightbox.close();
    }

    startInterval() {
      this.requestStatus$ = timer(0, this.timeInterval).pipe();
      this.sub = this.requestStatus$.subscribe((data) => {
        this.checkStatusSync();
      });
    }


    ngOnInit() {
        this.getList();
        this.startInterval();
    }

    getList() {
        this.mediaService.getList().subscribe(response => {
            this.basePath = response.result.basePath;
            this.products = response.result.assets.map((product) => {
                return {
                    ...product,
                    activePage: product.folders.reduce((acc, folder) => {
                        acc[folder.name] = 1;
                        return acc;
                    }, {})
                }
            });
            this.assetsVersion = response.result.assetsVersion;
            if (response.result.media.length) {
                this.media = this.createChangesObservation(response.result.media);
            }
        });
    }

    checkStatusSync() {
      this.mediaService.getStatusSyncS3().subscribe(res => {
        this.statusSync = res.result;
      });
    }

    syncS3() {
        if (this.isSync) {
            return;
        }
        this.isSync = true;
        this.mediaService.syncS3(this.selectedProducts).subscribe(res => {
            if (res.result) {
                this.selectedProducts = [];
                const filesCount = res.result;
                this.isSync = false;
                // const successMessage = await this.translateService.get('webpanel.sync.s3.success.message').toPromise();
                this.toasterService.pop('success', '', `${filesCount} files will sync`);
            }
        });
    }

    fileUpload(files: FileList, product, folder) {
        this.wichFolderUploading = product + folder;
        const path = `assets/${product}/${folder}`;
        const fileCount = files.length;
        let fileDone = 0;
        for(let i=0; i < fileCount; i++) {
          const fileToUpload = files.item(i);
          this.mediaService.uploadFile(fileToUpload, path).subscribe(
              async response => {
                  fileDone++;
                  this.toasterService.pop(
                      'success',
                      '',
                      (await this.translationService.get('webpanel.media.file_uploaded_successfully').toPromise())+'. ' + fileDone + ' out of ' + fileCount
                  );
                  if(fileDone == fileCount) {
                    this.wichFolderUploading = '';
                    this.getList();
                  }
              },
              async error => {
                  fileDone++;
                  this.wichFolderUploading = '';
                  console.log('error');
                  this.toasterService.pop(
                      'error',
                      await this.translationService.get('webpanel.media.file_upload_error').toPromise(),
                      error.message,
                  );
              }
          );
        }
    }

    imageUpload(files: FileList) {
        this.isImageUploading = true;
        const path = `images`;
        const fileToUpload = files.item(0);

        this.mediaService.uploadFile(fileToUpload, path).subscribe(
            async response => {
                this.isImageUploading = false;
                this.toasterService.pop(
                    'success',
                    '',
                    await this.translationService.get('webpanel.media.file_uploaded_successfully').toPromise()
                );

                this.getList();
            },
            async error => {
                this.isImageUploading = false;
                console.log('error');
                this.toasterService.pop(
                    'error',
                    '',
                    await this.translationService.get('webpanel.media.file_upload_error').toPromise()
                );
            }
        );
    }

    deleteFile(product, folder, image) {
        this.wichFileDeleting = product + folder + image;
        const pathToImage = `assets/${product}/${folder}/${image}`;
        this.mediaService.deleteFile(pathToImage).subscribe(
            async response => {

                this.products.forEach(p => {
                    if (p.name === product) {
                        p.folders.forEach((f: any) => {
                            if (f.name === folder) {
                                // f.files.filter() = f.files.filter();
                            }
                        });
                    }
                });

                this.wichFileDeleting = '';
                this.toasterService.pop(
                    'success',
                    '',
                    await this.translationService.get('webpanel.media.file_deleted_successfully').toPromise()
                );

                this.getList();
            },
            async error => {
                this.wichFileDeleting = '';
                this.toasterService.pop(
                    'error',
                    '',
                    await this.translationService.get('webpanel.media.file_delete_error').toPromise()
                );
            }
        );
    }

    deleteImage(image) {
        const  pathToImage = `images/${image}`;
        this.mediaService.deleteFile(pathToImage).subscribe(
            async response => {
                this.wichFileDeleting = '';
                this.toasterService.pop(
                    'success',
                    '',
                    await this.translationService.get('webpanel.media.file_deleted_successfully').toPromise()
                );

                this.getList();

            },
            async error => {
                this.toasterService.pop(
                    'error',
                    '',
                    await this.translationService.get('webpanel.media.file_delete_error').toPromise()
                );
            }
        );
    }

    deleteVideo(id) {
        this.mediaService.deleteVideo(id.toString()).subscribe(
            async response => {
                this.wichFileDeleting = '';

                this.toasterService.pop(
                    'success',
                    '',
                    await this.translationService.get('webpanel.media.file_deleted_successfully').toPromise()
                );

                this.getList();
            },
            async error => {
                this.toasterService.pop(
                    'error',
                    '',
                    await this.translationService.get('webpanel.media.file_delete_error').toPromise()
                );
            }
        );
    }

    addVideo() {
        this.media.forEach(mediaItem => {
            if (mediaItem.name === 'video') {
                mediaItem.files.push({
                    path: '',
                    title: '',
                });
            }
        });
        console.log(this.media);
    }

    getVideoThumbnail(link) {
        const youtubeId = this.getYoutubeId(link);
        return `https://img.youtube.com/vi/${youtubeId}/0.jpg`;
    }

    getYoutubeId(link) {
        if ((link && !link.length) || !link.includes('youtube')) {
            return '';
        }

        let videoId = link.split('v=')[1];
        const ampersandPosition = videoId.indexOf('&');
        if (ampersandPosition !== -1) {
            videoId = videoId.substring(0, ampersandPosition);
        }
        return videoId;
    }

    saveSettingsData () {
        this.mediaService.updateMediaInfo({ media: this.media }).subscribe(res => {
            console.log(res);
            this.getList();
        });
    }

    cancelChanges () {
        this.getList();
    }

    private createChangesObservation(settings) {
        this.changesCount = 0;
        this.haveChanges = false;
        const subject = this.datachanges.observe(settings);
        this.changesSubject = subject;
        subject.onChanges.subscribe((event) => {
            this.changesCount = event.subject.changesCount;
            this.haveChanges = this.changesCount > 0;
        });
        return subject.getProxy();
    }

    toggleAccordion(productName) {
        if (this.activeCollapse === productName) {
            this.activeCollapse = '';
        } else {
            this.activeCollapse = productName;
        }
    }

    getThumbnails(currentPage, thumbnails = []) {
        const startTableData = (this.thumbnailsOnPage * currentPage) - this.thumbnailsOnPage;
        const endTableData = (this.thumbnailsOnPage * currentPage);
        let data = thumbnails.slice(startTableData, endTableData);
        return data;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/media/media.component.ts